import { DOMHelper } from "./dom-helper";
import { MarketingClientConstants } from "../constants/marketing-client-constants";

export class PageInformationHelper {
    static getArticleId() {
        return DOMHelper.querySelector(MarketingClientConstants.rootElement)?.getAttribute("data-xx");
    }
}
